import React, { Component } from 'react';
import Literal from 'components/Literal'; // FIXME Please use getLiteral here
import CopyToClipboard from 'react-copy-to-clipboard';
import './styles.scss';

const CopyButton = (element, value, onCopy) => {
    return (
        <CopyToClipboard text={value} onCopy={onCopy}>
            {element}
        </CopyToClipboard>
    );
};

const ValueBox = ({ value, buttonLiteral, onCopy }) => {
    let buttonClasses = ['button'];
    if (!value) {
        buttonClasses.push('button-disabled');
    }
    let button = (
        <div className={buttonClasses.join(' ')}>
            <Literal literal={buttonLiteral} />
        </div>
    );
    if (value) {
        button = CopyButton(button, value, onCopy);
    }
    return (
        <div className="valuebox">
            <div className="value text-ellipsis">{value}</div>
            {button}
        </div>
    );
};

export default ValueBox;
